export default __webpack_public_path__ + "static/media/Dummy Gutschein.f28448c7.png";